<template lang="pug">
.v-btn-scroll-top.btn-scroll-top(v-if="!isSm" :class="{'btn-scroll-top--visible': isVisible}")
	button.btn-scroll-top__btn(type="button" @click="scrollToTop")
		v-svg-icon.btn-scroll-top__icon(icon="arrow-right")
</template>

<script>
import controller from '../scripts/controller/controller.js';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';

export default {
	mixins: [
		isMobMixin
	],

	data() {
		return {
			isVisible: false,
		};
	},

	mounted() {
		window.addEventListener('scroll', this.setVisibility, controller.passiveEventsSupported ? {passive: true} : undefined);
	},

	methods: {
		setVisibility() {
			if (window.scrollY > 500) {
				this.isVisible = true;
			} else {
				this.isVisible = false;
			}
		},

		scrollToTop() {
			window.scrollTo({top: 0, behavior: 'smooth'});
		}
	}
};
</script>
